import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CpService {
  private apiKey = 'zp_94b3d69e9bdedcb96da82dca3290b7bc7f03666229fae5e8';

  constructor(private http: HttpClient) { }

  getDatosPorCp(cp: string): Observable<any> {
    // Definimos los encabezados requeridos por la API
    const headers = new HttpHeaders({
      'X-API-Key': this.apiKey
    });

    // Angular usa HttpClient para retornar un Observable automáticamente
    return this.http.get(`https://api.codigos.zip/api/zip/${cp}?pais=MX`, { headers });
  }
}


// WEBPACK FOOTER //
// ./src/app/services/cp.service.ts